@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.verify-header {
  background-color: @scan-page--verify-header--background-color;
  border-bottom: 1px solid @scan-page--verify-header--border-color;
  padding: 10px 15px;
  align-items: center;
  justify-content: space-between;

  .user-input {
    flex: 1;
    align-items: center;
  }
  .marketplace-adjustment-alert {
    flex: 1;
    justify-content: flex-end;
  }
}

.adjustment-wrap {
  display: flex;
  align-items: center;
  background-color: @scan-page--verify-header-adjustment--background-color;
  border-radius: 4px;
  font-size: 14px;
  max-width: 450px;
  &.non-zero {
    background-color: @scan-page--verify-header-adjustment-non-zero--background-color;
  }
}

.icon-wrap {
  margin: 10px 5px 10px 10px;
  border-right: 1px solid @scan-page--verify-header-icon--border-color;
  padding-right: 5px;
}

.message-wrap {
  margin: 10px 10px 10px 0;
}

.adjustment-icon {
  height: 16px;
  width: 16px;
  fill: @scan-page--verify-header-adjustment-icon--border-color;
}

.adjustments-message {
  margin-right: 5px;
}
